import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { StatusMap } from '@enums/StatusMap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColorType, IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-custom-cell-status',
    templateUrl: './custom-cell-status.component.html',
    styleUrls: ['./custom-cell-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CustomCellStatusComponent implements ICellRendererAngularComp {
    text = '';
    svg?: SafeHtml;
    colorType: ColorType = 'idle';

    constructor(private readonly iconSanitizer: IconSanitizerService) {}
    agInit(params: any): void {
        const rawValue = params.value;

        let statusId: number | null = null;
        let label = '';

        if (typeof rawValue === 'object' && rawValue !== null) {
            statusId = rawValue.id ?? null;
            label = rawValue.label ?? '';
        } else if (typeof rawValue === 'string') {
            label = rawValue;
        }

        if (statusId !== null && statusId in StatusMap) {
            const statusEntry = StatusMap[statusId as keyof typeof StatusMap];
            this.setFromEntry(statusEntry);
            return;
        }

        const entry = Object.values(StatusMap).find((e) => e.text === label);
        if (entry) {
            this.setFromEntry(entry);
            return;
        }

        this.text = label;
        this.colorType = 'idle';
        this.svg = undefined;
    }

    private setFromEntry(entry: { icon: string; text: string; colorType: ColorType }): void {
        this.text = entry.text;
        this.colorType = entry.colorType;
        this.svg = this.iconSanitizer.getIcon(entry.icon);
    }

    refresh(): boolean {
        return false;
    }
}
